/* Display-only currency conversion for SHEN (EGP -> USD / EUR / SAR / AED).
   Orders are always charged in EGP: the store has no gateway supporting native
   multi-currency, so conversion is purely visual, done on rendered DOM text.
   The shop money format is "LE {{amount}}", which is the pattern matched below;
   static copy written as "E£" (e.g. the shipping fee table) is deliberately
   left untouched. Mark any element with data-no-convert to exclude it. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;

  var BASE = 'EGP';
  var CURRENCIES = {
    EGP: { label: 'EGP ج.م', flag: 'eg', prefix: null },
    USD: { label: 'USD $', flag: 'us', prefix: '$ ' },
    EUR: { label: 'EUR €', flag: 'eu', prefix: '€ ' },
    SAR: { label: 'SAR ر.س', flag: 'sa', prefix: 'SAR ' },
    AED: { label: 'AED د.إ', flag: 'ae', prefix: 'AED ' }
  };
  /* Fallback rates (1 EGP -> X), snapshot 2026-07-30; refreshed at runtime. */
  var FALLBACK = { USD: 0.019726, EUR: 0.01732, SAR: 0.073975, AED: 0.072446 };
  var STORE_KEY = 'shen:currency';
  var RATES_KEY = 'shen:fx-rates';
  var RATES_TTL = 12 * 60 * 60 * 1000;
  var MONEY_RE = /LE\s?(\d[\d,]*(?:\.\d{1,2})?)(\s*EGP)?/g;

  var rates = FALLBACK;
  var current = BASE;
  var originals = new WeakMap(); /* Text node -> original EGP string */
  var written = new WeakMap();   /* Text node -> last value we wrote (self-mutation filter) */

  try {
    var cached = JSON.parse(localStorage.getItem(RATES_KEY) || 'null');
    if (cached && cached.rates && cached.rates.USD && Date.now() - cached.ts < RATES_TTL) {
      rates = cached.rates;
    } else {
      fetch('https://open.er-api.com/v6/latest/EGP')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.result === 'success' && d.rates && d.rates.USD) {
            rates = { USD: d.rates.USD, EUR: d.rates.EUR, SAR: d.rates.SAR, AED: d.rates.AED };
            try { localStorage.setItem(RATES_KEY, JSON.stringify({ ts: Date.now(), rates: rates })); } catch (e) {}
            if (current !== BASE) applyAll();
          }
        })
        .catch(function () {});
    }
  } catch (e) {}

  function format(amountEgp, code) {
    var rate = rates[code] || FALLBACK[code];
    return CURRENCIES[code].prefix + (amountEgp * rate).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function convertNode(node) {
    var original = originals.get(node);
    if (original == null) {
      MONEY_RE.lastIndex = 0;
      if (!MONEY_RE.test(node.data)) return;
      original = node.data;
      originals.set(node, original);
    }
    var out = current === BASE ? original : original.replace(MONEY_RE, function (_m, num) {
      return format(parseFloat(num.replace(/,/g, '')), current);
    });
    if (node.data !== out) {
      written.set(node, out);
      node.data = out;
    }
  }

  function walk(root) {
    if (root.nodeType === 3) { convertNode(root); return; }
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA') return NodeFilter.FILTER_REJECT;
        if (p.closest('[data-no-convert]')) return NodeFilter.FILTER_REJECT;
        if (originals.has(n)) return NodeFilter.FILTER_ACCEPT;
        MONEY_RE.lastIndex = 0;
        return MONEY_RE.test(n.data) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(convertNode);
  }

  function updateSelectors() {
    var c = CURRENCIES[current];
    document.querySelectorAll('[data-currency-selector]').forEach(function (root) {
      var flag = root.querySelector('[data-currency-flag]');
      var label = root.querySelector('[data-currency-label]');
      if (flag) flag.src = '//cdn.shopify.com/static/images/flags/' + c.flag + '.svg?format=jpg&width=60';
      if (label) label.textContent = c.label;
      root.querySelectorAll('[data-currency]').forEach(function (btn) {
        btn.setAttribute('aria-selected', String(btn.getAttribute('data-currency') === current));
      });
    });
  }

  function applyAll() {
    walk(document.body);
    updateSelectors();
  }

  function setCurrency(code) {
    current = CURRENCIES[code] ? code : BASE;
    try { localStorage.setItem(STORE_KEY, current); } catch (e) {}
    applyAll();
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-currency]');
    if (!btn || !CURRENCIES[btn.getAttribute('data-currency')]) return;
    setCurrency(btn.getAttribute('data-currency'));
    var popover = btn.closest('x-popover');
    if (popover && typeof popover.hide === 'function') popover.hide();
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'characterData') {
        /* Ignore our own writes; any other writer just replaced the text with
           fresh EGP output, so the stored original is stale. */
        if (written.get(m.target) === m.target.data) return;
        originals.delete(m.target);
        if (current !== BASE) convertNode(m.target);
      } else if (current !== BASE) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 3) originals.delete(n);
          walk(n);
        });
      }
    });
  });

  function init() {
    var initial = BASE;
    var hash = location.hash.match(/currency=([A-Za-z]{3})/);
    if (hash) {
      initial = hash[1].toUpperCase();
    } else {
      try { initial = localStorage.getItem(STORE_KEY) || BASE; } catch (e) {}
    }
    current = CURRENCIES[initial] ? initial : BASE;
    if (hash) { try { localStorage.setItem(STORE_KEY, current); } catch (e) {} }
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    applyAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.SHENCurrency = {
    set: setCurrency,
    get: function () { return current; },
    rates: function () { return rates; }
  };
})();
